<div class="filter">
  <div class="sample-container" *ngIf="show">
    <po-loading-overlay></po-loading-overlay>
  </div>
  <div class="po-row welcome-filter">
    <form #f="ngForm">
      <div class="p-d-flex">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <div class="po-xl-4 po-lg-4 po-md-4 po-sm-5">
          <po-datepicker name="minDate" [(ngModel)]="minDate" p-clean p-label="Data inicial" [p-max-date]="maxDate" [p-min-date]="minDateNoventa"
            [p-format]="format" p-placeholder="Hoje" (p-change)="validateDateMin()">
          </po-datepicker>
        </div>
        <div class="po-xl-4 po-lg-4 po-md-4 po-sm-5">
          <po-datepicker name="maxDate" [(ngModel)]="maxDate" p-clean p-label="Data final" [p-format]="format"
            [p-max-date]="toDay" p-placeholder="Hoje" (p-change)="changeMinDateNoventa()">
          </po-datepicker>
        </div>
      </div>
      <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <div class="po-row" *ngIf="routerMoment.url === '/home/sale'">
          <div class="po-xl-5 po-lg-5 po-md-5 po-sm-5 po-mt-1">
            <po-multiselect p-label="Filial" name="branchSelected" p-label="Filial" [p-options]="brachList" p-placeholder="Selecione uma Filial" [(ngModel)]="branchSelected" (p-change)="recoverSellersList()"></po-multiselect>
          </div>
          <div class="po-xl-7 po-lg-7 po-md-7 po-sm-7 po-mt-1">
            <po-select p-label="Vendedor(a)" name="sellerSelected" (p-change)="recoverSellerSelected($event)"
              [ngModel]="sellerSelected" [p-options]="sellerList" p-placeholder="Selecione um vendedor(a)">
            </po-select>
          </div>
        </div>
        <div class="po-row" *ngIf="routerMoment.url === '/home/salers'">
          <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mt-1">
            <po-multiselect p-label="Filial" name="branchSelected" p-label="Filial" [p-options]="brachList" p-placeholder="Selecione uma Filial" [(ngModel)]="branchSelected" (p-change)="recoverBranchSellersList(true)"></po-multiselect>
          </div>
        </div>
        <div class="po-row">
          <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mt-1" *ngIf="routerMoment.url === '/home/financial'">
            <po-multiselect p-label="Filial" name="branchSelected" p-label="Filial" [p-options]="brachList" p-placeholder="Selecione uma Filial" [(ngModel)]="branchSelected" (p-change)="recoverSellersList()"></po-multiselect>
          </div>
        </div>
        <div class="po-row" *ngIf="routerMoment.url === '/home/manufacturing'">
          <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 po-mt-1">
            <po-select *ngIf="typeClassificationList" p-label="Tipo de classificação" name="typeClassificationSelected" (p-change)="recoverTypeClassificationSelected($event)"
              [ngModel]="typeClassificationSelected" [p-options]="typeClassificationList" p-placeholder="Selecione um tipo de classificação">
            </po-select>
          </div>
          <div class="po-xl-5 po-lg-5 po-md-5 po-sm-5 po-mt-1">
            <po-multiselect p-label="Filial" name="branchSelectedManufacturing"
              [(ngModel)]="branchSelectedManufacturing" [p-options]="brachList" p-placeholder="Selecione uma Filial">
            </po-multiselect>
          </div>
          <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 po-mt-1">
            <po-select *ngIf="typeClassificationLocationList" p-label="Tipo de class. local" name="typeClassificationLocationSelected" (p-change)="recoverTypeClassificationLocationSelected($event)"
              [ngModel]="typeClassificationLocationSelected" [p-options]="typeClassificationLocationList" p-placeholder="Selecione um tipo de classificação">
            </po-select>
          </div>
          <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 po-mt-1">
            <po-multiselect name="multiselect" p-label="Tipo de produto" [p-options]="options" [(ngModel)]="multiselect"> </po-multiselect>
          </div>
        </div>

        <div class="po-row">
          <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-pt-1 po-pb-1 po-text-right">
            <po-button p-label="Aplicar filtro" (p-click)="onFilter()"> </po-button>
          </div>
        </div>
      </div>
      </div>
    </form>
  </div>
</div>
